<template>
	<div class="">
		<h1>Status TO</h1>
		<hr>
		<!-- FILTER START -->
		<panel class="border border-secondary" :noExpand="true">
			<template slot="header">
			<h4 class="panel-title">Filter Option</h4>
			</template>
			<div class="row outerBox filterBox">
				<div class="col row">
					<!-- <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
					<label for="dateTimeInput">From</label>
					<flat-pickr
						v-model="filter.start"
						:config="seperatedRangeConfig"
						placeholder="Select From Date"
					/>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
					<label for="dateTimeInput">To</label>
					<flat-pickr
						v-model="filter.end"
						:config="seperatedRangeConfig"
						placeholder="Select To Date"
					/>
					</div> -->
					<!-- <div class="col-12 col-md-6">
						<label>Karesidenan</label>
						<Multiselect 
							:options="options.karesidenan.map(x => x.code)"
							:custom-label="opt => options.karesidenan.find(x => x.code  == opt).name"
							v-model="selected.karesidenan"
						/>
					</div> -->
					<!-- <div class="col-12 col-md-6">
						<label>City</label>
						<Multiselect 
							:options="options.city.map(x => x.code)"
							:custom-label="opt => options.city.find(x => x.code == opt).name"
							v-model="selected.city"
						/>
					</div> -->
					<div class="col-12 col-md-6">
						<label>Date Range</label>
						<flat-pickr
							v-model="selected.date"
							:config="rangeConfig"
							placeholder="Select To Date"
						/>
					</div>
					<div class="col-12 col-md-6">
						<!-- <label>Dealer</label>
						<Multiselect 
							:options="options.dealer.map(x => x.code)"
							:custom-label="opt => options.dealer.find(x => x.code == opt).name"
							v-model="selected.dealer"
						/> -->
					</div>
					<div class="col-md-4 row" style="padding-top:26px">
					<button class="btn btn-primary w-100" type="button" @click="search()">
						<span class="fa fa-filter"></span>&nbsp;&nbsp;Search
					</button>
					</div>
				</div>
			</div>
		</panel>

		<div class="text-right mt-3 mb-3">
			<button class="btn btn-success" @click="downloadData">Download Excel</button>
		</div>
		
		<div style="height:600px;overflow-y:scroll">
			<table class="table mt-4 text-center" v-if="data" style="font-size:14px;">
				<thead>
					<th>Nomor TO</th>
					<th>Status</th>
					<th>Tanggal Kirim</th>
					<th>Driver Pengirim</th>
					<th>Truk Pengirim</th>
					<th></th>
				</thead>
				<tbody v-for="dat in data" :key="data.no_referensi">
					<tr>
						<td>{{dat.no_referensi}}</td>
						<td>-</td>
						<td>{{dat.tgl_sl}}</td>
						<td>{{dat.driver}}</td>
						<td>{{dat.nopol}}</td>
						<td>
							<i v-if="dat.hide" class="fa fa-arrow-down" style="color:red" @click="dat.hide = !dat.hide"></i>
							<i v-else class="fa fa-arrow-up" style="color:green" @click="dat.hide = !dat.hide"></i>
						</td>
					</tr>

					<tr v-if="!dat.hide">
						<td colspan="10">
							<div style="height:200px;overflow-y:scroll">
								
								<table class="table table-borderless" style="color:#777">
									<thead>
										<th>Nomor SL</th>
										<th>Status</th>
										<th>Tanggal Kirim</th>
										<th>Driver Pengirim</th>
										<th>Truk Pengirim</th>
									</thead>
									<tbody v-for="sl in dat.sl" >
										<tr >
											<td>{{sl.no_sl}}</td>
											<td>{{sl.status}}</td>
											<td>{{sl.tgl_sl}}</td>
											<td>{{sl.driver}}</td>
											<td>{{sl.nopol}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</td>
						
						<!-- <td>
							<i v-if="dat.hide" class="fa fa-arrow-down" style="color:red" @click="dat.hide = !dat.hide"></i>
							<i v-else class="fa fa-arrow-up" style="color:green" @click="dat.hide = !dat.hide"></i>
						</td> -->
					</tr>
				</tbody>
			</table>
		</div>


	</div>
</template>

<script>
import moment from 'moment'
const XLSX = require('xlsx')
import Datepicker from 'vuejs-datepicker'
import Multiselect  from 'vue-multiselect'
import flatPickr from 'vue-flatpickr-component'

export default {
	components : {
		Multiselect, 
		flatPickr
	},
	data () {
		let date = `${new moment().startOf('month').format('Y-MM-DD')} to ${new moment().endOf('month').format('Y-MM-DD')}`
		return {
			data : null,
			options : this.$store.getters.getFilterOptions,
			rangeConfig: {
				mode: 'range',
				altInput: true,
				altInputClass: 'form-control input flatpickr-input',
				animate: !this.isRTL()
			},
			
			selected : {
				date : date,
				karesidenan : null,
				dealer : null,
				city : null
			},
			filter : {
				start : date.split(' to ')[0],
				end : date.split(' to ')[1],
			}
		}
	},
	watch : {
		'selected.karesidenan' : function () {
			this.loadFilter('karesidenan')
		},
		'selected.city' : function () {
			this.loadFilter('city')
		},
		'selected.date' : function () {
			this.filter.start = this.selected.date.split(' to ')[0]
			this.filter.end = this.selected.date.split(' to ')[1] ? this.selected.date.split(' to ')[1] : this.selected.date.split(' to ')[0]
		}
	},
	mounted () {
		this.loadData()
	},
	methods : {
		async loadData() {
			this.data = null
			let stringUrl = await this.initialiseFilter()

			this.$http.get('/api/reports/to-status-report' + stringUrl)
			.then((resp) => {
				this.data = resp.data.data

				for(var i = 0 ; i < this.data.length ; i++) {
					this.$set(this.data[i] , 'hide' , true)
				}
			})
			.catch((err)=> {
				console.log(err)
			})
		},
		search() {
			// let obj = Object.assign({} , this.selected)
			// obj.start = obj.date.split(' to ')[0]
			// obj.end = obj.date.split(' to ')[1]
			// delete obj.date;

			// this.filter = obj
			
			// this.loadData()
			this.loadData()
		},
		loadFilter(type){
			let city = []
			if(this.selected.city) city.push({code : this.selected.city})

			let karesidenan = []
			if(this.selected.karesidenan) karesidenan.push({code : this.selected.karesidenan})

			if (type == 'karesidenan'){
				this.selected.city = null;
				this.options.city = this.$store.getters.getCity(karesidenan)
				
				this.selected.dealer= null;
				this.options.dealer = this.$store.getters.getDealer(karesidenan, city)
			} else if (type == 'city'){
				this.selected.dealer = null;
				this.options.dealer = this.$store.getters.getDealer(karesidenan, city)
			} 
		},
		initialiseFilter(){
			if(!(typeof this.filter === 'object' && this.filter !== null)){
				this.filterUrl = '';
				return;
			}
			var keys = Object.keys(this.filter);
			let stringUrl = '?';
			var queryParams = this.filter;

			for(var i = 0 ; i < keys.length; i++){
				if(!queryParams[keys[i]])
					continue;

				if(queryParams[keys[i]] == '' || queryParams[keys[i]].length == 0)
					continue 

				if((keys[i] == 'user_type') && queryParams[keys[i]] == 'All')
					continue;
				
				// if(keys[i] == 'start_hour' || keys[i] == 'end_hour')
				//   queryParams[keys[i]] += ":00";
				
				if([keys[i]] == 'start' || keys[i] == 'end') queryParams[keys[i]] = moment(queryParams[keys[i]]).format('Y-MM-DD')
				

				stringUrl += `&${keys[i]}=${queryParams[keys[i]]}`;
			
			}
			console.log(stringUrl)
			return stringUrl;
		},
		async downloadData () {
			let data = Object.assign({} , this.data)

			let tempArr = []

			
			// for(var i = 0 ; i < data.length ; i++) {
			// 	delete data[i].hide

			// 	let sl = data[i].sl.slice()

			// 	delete data[i].sl

			// 	data[i][' '] = ''

			// 	tempArr.push(data[i])
				
			// 	sl = await this.parseArr(sl)
			// 	tempArr.concat(sl)
			// }
			let i = 0;
			tempArr = await this.recursiveArr(data , i , tempArr)

			console.log(tempArr)


			this.exportFile(tempArr)
			
		},
		async recursiveArr (data , i , tempArr){
			let curData = data[i]
			if(!curData) return tempArr

			delete curData.hide
			tempArr.push(curData)
			curData.tgl_kirim = curData.tgl_sl

			delete curData.tgl_sl

			let sl = curData.sl
			let j = 0
			sl = await this.parseArr(sl , j , [])
			// delete curData.sl
			console.log(sl)
			tempArr = tempArr.concat(sl)

			delete curData.sl
			i++;

			return this.recursiveArr( data, i, tempArr)
		},

		async parseArr(sl , j , tempArr) {
			let curSl = sl[j]

			if(!curSl) return tempArr
			let obj = {
				no_sl : curSl.no_sl,
				status_sl : curSl.status,
				tanggal_kirim_sl : curSl.tgl_sl,
				driver_pengirim : curSl.driver,
				truk_pengirim : curSl.nopol
			}

			tempArr.push(obj)
			j++;
			return this.parseArr(sl , j , tempArr)
		},

		// async parseArr(array) {
		// 	for(var i = 0 ; i < array.length ; i++) {
		// 		let curArr = array[i]

		// 		let obj = {
		// 			no_referensi : '',
		// 			status : curArr.no_sl,
		// 			tanggal_kirim : curArr.status,
		// 			driver_pengirim : curArr.tanggal_kirim,
		// 			truk_pengirim : curArr.driver_pengirim,
		// 			' ' : curArr.truk_pengirim
		// 		}

		// 		curArr = obj
		// 	}

		// 	return array
		// },
		exportFile(data){
			let wb = XLSX.utils.book_new()
			var ws = XLSX.utils.json_to_sheet(data, {raw:true});
			XLSX.utils.book_append_sheet(wb, ws, 'Data')

			let exportFileName = `Export Status TO ${this.filter.start} - ${this.filter.end}.xlsx`
			XLSX.writeFile(wb, exportFileName)
		},
	}
}
</script>